import { Anchor, Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { ALEXANDRIA_URL } from "@/alexandria/constants";
import { rootCss } from "./EditContentTools.style";

const propTypes = {
  contentId: PropTypes.string.isRequired,
  isArticle: PropTypes.bool,
};

const EditContentTools = ({ contentId, isArticle = true }) => {
  const path = isArticle ? "articles" : "inventory";
  const href = `${ALEXANDRIA_URL}/${path}/${contentId}`;
  const title = isArticle ? "Edit article" : "Edit content";

  return (
    <Anchor
      href={href}
      styleAnchorAsButton={{
        size: Button.sizes.lg,
        flavor: Button.flavors.secondary,
      }}
      __cssFor={{
        root: rootCss,
      }}
    >
      {title}
    </Anchor>
  );
};

EditContentTools.propTypes = propTypes;

export default EditContentTools;
